import styled, { css } from 'styled-components';

export const Container = styled.div<{ isDialog?: boolean }>`
  display: flex;
  flex-direction: column;
  ${({ isDialog }) =>
    !isDialog &&
    css`
      width: 100%;
      height: 100%;
      padding: 0 16px;
      overflow-y: auto;
    `}
`;
